/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailItemInvoice_item = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpSharedDetailItemInvoice_item";
};
export type PdpSharedDetailItemInvoice_item$data = PdpSharedDetailItemInvoice_item;
export type PdpSharedDetailItemInvoice_item$key = {
    readonly " $data"?: PdpSharedDetailItemInvoice_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailItemInvoice_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '70aba8784376d80475654a82ae87f2d8';
export default node;
